// @flow
import { makeApiCall } from '../../../../services/apiService/apiService';

export const addCellPrefixModalActions = {
  GET_AVAILABLE_CELLS_WITHOUT_SAVE: 'GET_AVAILABLE_CELLS_WITHOUT_SAVE'
};

export const getAvailableCellsWithoutSave = (obj: Object) => ({
  type: addCellPrefixModalActions.GET_AVAILABLE_CELLS_WITHOUT_SAVE,
  payload: obj
});

export const getCellDtoListWithoutSaveAction = (apiRequestObj: Object) => (
  dispatch: Function
) => {
  dispatch(
    getAvailableCellsWithoutSave({
      isLoading: true,
      isLoaded: false,
      cells: []
    })
  );

  // eslint-disable-next-line no-console
  console.log('createCellDtoListWithoutSave called ');
  const requestObj = {
    baseUrl: 'zoomWmsBaseUrl',
    apiEndPoint: 'createCellDtoListWithoutSave',
    method: 'GET',
    params: apiRequestObj,
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched cells ', res);
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          cells: res.payload
        };
        dispatch(getAvailableCellsWithoutSave(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getAvailableCellsWithoutSave({
            isLoading: false,
            isLoaded: true,
            cells: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Failure in fetching cells, res= ', res);
      dispatch(
        getAvailableCellsWithoutSave({
          isLoading: false,
          isLoaded: true,
          cells: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching cells ', res);
      dispatch(
        getAvailableCellsWithoutSave({
          isLoading: false,
          isLoaded: true,
          cells: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};
